import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Privacy from "@/pages/Privacy";
import CookieBanner from "@/components/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "rgba(10,15,28,0.85)",
            border: "1px solid rgba(0,229,255,0.25)",
            color: "#fff",
            backdropFilter: "blur(14px)",
          },
        }}
      />
    </div>
  );
}

export default App;
